import React from "react";
import styled from "styled-components";

import loadingGif from "../images/ajax-loader.gif";

const StyledLoadingBox = styled.div`
  width: 100%;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Loading = () => (
  <StyledLoadingBox>
    <img src={loadingGif} alt="animated loading graphic" />
  </StyledLoadingBox>
);

export default Loading;
